import { ComponentPropsWithoutRef } from 'react';

export function Thead(props: ComponentPropsWithoutRef<'thead'>) {
  return (
    <thead
      {...props}
      className="text-grayscale600 border-b-grayscale100 border-b"
    />
  );
}
